webpackJsonp([213187215133716],{

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Fischer.14092644.jpg";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/Mueller.2725b899.jpg";

/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var logo = __webpack_require__(40);
	var imgFischer = __webpack_require__(464);
	var imgMueller = __webpack_require__(465);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'head' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement('img', { src: logo, alt: 'DAN EV - Dienst am N\xE4chsten', className: 'logo' }),
	        _react2.default.createElement(
	          'span',
	          {
	            id: 'global-slogan',
	            'data-editable': 'simpletext',
	            className: 'slogan',
	            'data-global': 'data-global'
	          },
	          'Nachbarschaftshilfe',
	          _react2.default.createElement('br', null),
	          'von Mensch zu Mensch'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'hotline' },
	          _react2.default.createElement(
	            'strong',
	            {
	              id: 'global-fragen',
	              'data-editable': 'simpletext',
	              'data-global': 'data-global'
	            },
	            'Sie haben Fragen?'
	          ),
	          _react2.default.createElement('br', null),
	          _react2.default.createElement(
	            'span',
	            {
	              id: 'global-phone',
	              'data-editable': 'simpletext',
	              'data-global': 'data-global'
	            },
	            '0174/3444893',
	            _react2.default.createElement('br', null)
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'nav' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'clearfix' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/home' },
	              'Startseite'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: 'active' },
	            _react2.default.createElement(
	              'a',
	              { href: '/geschichte', className: 'active' },
	              '\xDCber Uns'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/dienstleistungen' },
	              'Dienstleistungen'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/sie-wollen-helfen' },
	              'Sie wollen helfen?'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/mitglieder' },
	              'Mitglieder'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/kontakt' },
	              'Kontakt'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          { id: 'geschichte', 'data-editable': 'simpletext', className: 'mb1' },
	          'Geschichte'
	        ),
	        _react2.default.createElement(
	          'p',
	          { id: 'geschichte-p', 'data-editable': 'text' },
	          'Dienst am N\xE4chsten e. V. wurde im Mai 2008 von Edith Scheffold und Wolfgang Seibold unter Mithilfe von Sandra und Andreas Baier gegr\xFCndet. Sie machten sich zum Ziel, niederschwellige und unb\xFCrokratische Hilfen f\xFCr Seniorinnen und Senioren anzubieten. Als zentrales Angebot entstand die Nachbarschaftshilfe. Aufgrund des Ausscheidens der langj\xE4hrigen Verwaltungskraft stand DAN 2019 vor der Herausforderung, die administrativen Notwendigkeiten einer gro\xDFen Nachbarschaftshilfe zu bew\xE4ltigen. Die Vorst\xE4nde einigten sich schlie\xDFlich auf die \xDCbergabe der Tr\xE4gerschaft der Nachbarschaftshilfe an die Paul Wilhelm von Keppler-Stiftung. Seit 1. Januar 2020 organisiert somit die Katholische Sozialstation Ulm, als Einrichtung der Keppler-Stiftung, die Nachbarschaftshilfe DAN sowie den Caf\xE9-Betrieb im Seniorenzentrum Clarissenhof.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	          'p',
	          { id: 'vorstand', 'data-editable': 'text' },
	          'Unser Vereinsvorstand setzt sich zusammen aus:'
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'table', 'data-editable': 'text' },
	          _react2.default.createElement(
	            'table',
	            { cellPadding: 1, cellSpacing: 0, style: { width: 413 } },
	            _react2.default.createElement(
	              'tbody',
	              null,
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Gerhard Fischer'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '- Vorstandsvorsitzender'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Armin M\xFCller'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '- 2. Vorstand'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Andreas Baier'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '- Gesch\xE4ftsf\xFChrer'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Sandra Baier'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '- Schriftf\xFChrerin'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'August Kneer'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '- Beisitzer'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Reinhold Eichhorn'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '- Beisitzer'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  'Walter Feucht'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '- Beisitzer'
	                )
	              ),
	              _react2.default.createElement(
	                'tr',
	                null,
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '\xA0'
	                ),
	                _react2.default.createElement(
	                  'td',
	                  null,
	                  '\xA0'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'section',
	          { className: 'vorstanede' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4' },
	              _react2.default.createElement('img', {
	                src: imgFischer,
	                alt: 'Fischer.JPG',
	                id: 'vorstand-img-2',
	                'data-editable': 'image',
	                className: 'ccm-image-block',
	                height: 300
	              }),
	              _react2.default.createElement(
	                'p',
	                {
	                  id: 'vorstand-p-2',
	                  'data-editable': 'simpletext',
	                  className: 'mt1 text-center'
	                },
	                'Gerhard Fischer'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-4' },
	              _react2.default.createElement('img', {
	                src: imgMueller,
	                alt: true,
	                id: 'vorstand-img-3',
	                'data-editable': 'image',
	                className: 'ccm-image-block',
	                height: 300
	              }),
	              _react2.default.createElement(
	                'p',
	                {
	                  id: 'vorstand-p-3',
	                  'data-editable': 'simpletext',
	                  className: 'mt1 text-center'
	                },
	                'Armin M\xFCller'
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-geschichte-js-feb24d4fc8eb07aaff5c.js